module.exports = __webpack_public_path__ + "static/media/biMEX.158e63a0.png";